import reduxApi from 'redux-api';
import { tokenOptions, adapterJquery, baseApiUrl } from './ApiHelpers';

export default reduxApi({
  me: {
    url: `${baseApiUrl}/v1/ssps/me`,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  meUpdate: {
    url: `${baseApiUrl}/v1/ssps/me`,
    virtual: true,
    helpers: {
      post(data) {
        return [{}, {
          data,
          method: 'PUT'
        }];
      }
    }
  },
  websiteStats: {
    url: `${baseApiUrl}/v1/ssp/websites/:id/stats`,
    helpers: {
      get(id) {
        return [{ id }, {
           method: 'GET'
        }];
      }
    }
  },
  websites: {
    url: `${baseApiUrl}/v1/ssp/websites`,
    options: {
      method: 'GET'
    }
  },
  websiteCreate: {
    url: `${baseApiUrl}/v1/ssp/websites`,
    virtual: true,
    helpers: {
      post(data) {
        const jdx_min_cpa = data.website.jdx_min_cpa ? data.website.jdx_min_cpa * 1000 : undefined;
        const jdx_min_cpc = data.website.jdx_min_cpc ? data.website.jdx_min_cpc * 1000 : undefined;
        const feed_min_cpc = data.website.feed_min_cpc ? data.website.feed_min_cpc * 1000 : undefined;
        const website = { ...data.website };        
        if (jdx_min_cpa) website.jdx_min_cpa = jdx_min_cpa;
        if (jdx_min_cpc) website.jdx_min_cpc = jdx_min_cpc;
        if (feed_min_cpc) website.feed_min_cpc = feed_min_cpc;

        return [{}, {
          data: { website },
          method: 'POST'
        }];
      }
    }
  },
  websiteUpdate: {
    url: `${baseApiUrl}/v1/ssp/websites/:id`,
    virtual: true,
    helpers: {
      post(id, data) {
        const jdx_min_cpa = data.website.jdx_min_cpa ? data.website.jdx_min_cpa * 1000 : undefined;
        const jdx_min_cpc = data.website.jdx_min_cpc ? data.website.jdx_min_cpc * 1000 : undefined;
        const feed_min_cpc = data.website.feed_min_cpc ? data.website.feed_min_cpc * 1000 : undefined;
        const website = { ...data.website };        
        if (jdx_min_cpa) website.jdx_min_cpa = jdx_min_cpa;
        if (jdx_min_cpc) website.jdx_min_cpc = jdx_min_cpc;
        if (feed_min_cpc) website.feed_min_cpc = feed_min_cpc;

        const filters = { ...data.filters };
        const ad_slots = { ...data.ad_slots };

        return [{ id }, {
          data: { website, filters, ad_slots },
          method: 'PUT'
        }];
      }
    }
  },
  websiteDelete: {
    url: `${baseApiUrl}/v1/ssp/websites/:id`,
    virtual: true,
    helpers: {
      post(id) {
        return [{ id }, {
           method: 'DELETE'
        }];
      }
    }
  },
  reports: {
    url: `${baseApiUrl}/v1/ssp/reports`,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  adReports: {
    url: `${baseApiUrl}/v1/ssp/ad_reports`,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  pixel: {
    url: `${baseApiUrl}/v1/ssp/pixels`,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  adSlots: {
    url: `${baseApiUrl}/v1/ssp/ad_slots`,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  adSlotsVirtual: {
    url: `${baseApiUrl}/v1/ssp/ad_slots`,
    virtual: true,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  adSlotUpdate: {
    url: `${baseApiUrl}/v1/ssp/ad_slots/:id`,
    virtual: true,
    helpers: {
      post(id, ssp_website_id, data) {
        return [{ id, ssp_website_id }, {
          data: { 
            ad_slot: { 
              ...data.ad_slot
            } 
          },
          method: 'PUT'
        }];
      }
    }
  },
  filters: {
    url: `${baseApiUrl}/v1/ssp/filters`,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  filtersVirtual: {
    url: `${baseApiUrl}/v1/ssp/filters`,
    virtual: true,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  filterUpdate: {
    url: `${baseApiUrl}/v1/ssp/filters/:id`,
    virtual: true,
    helpers: {
      post(id, ssp_website_id, data) {
        return [{ id, ssp_website_id }, {
          data: { 
            ad_slot: { 
              ...data.ad_slot
            } 
          },
          method: 'PUT'
        }];
      }
    }
  },
  feeds: {
    url: `${baseApiUrl}/v1/ssp/feeds`,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  feedSources: {
    url: `${baseApiUrl}/v1/ssp/feed_sources`,
    options: {
      method: 'GET'
    }
  },
  feedCreate: {
    url: `${baseApiUrl}/v1/ssp/feeds`,
    virtual: true,
    helpers: {
      post(ssp_website_id, data) {
        return [{ ssp_website_id }, {
          data: { 
            feed: { 
              ...data.feed
            } 
          },
          method: 'POST'
        }];
      }
    }
  },
  feedUpdate: {
    url: `${baseApiUrl}/v1/ssp/feeds/:id`,
    virtual: true,
    helpers: {
      post(id, ssp_website_id, data) {
        return [{ id, ssp_website_id }, {
          data: { 
            feed: { 
              ...data.feed
            } 
          },
          method: 'PUT'
        }];
      }
    }
  },
  feedDelete: {
    url: `${baseApiUrl}/v1/ssp/feeds/:id`,
    virtual: true,
    helpers: {
      post(id, ssp_website_id) {
        return [{ id, ssp_website_id }, {
           method: 'DELETE'
        }];
      }
    }
  },
}).use('options', tokenOptions).use('fetch', adapterJquery);
